// 替换天眼方案
import { SailingRaven } from '@didi/sailing-data-tools'
const isPro = process.env.NODE_ENV === 'production'

export const initRaven = (uid = '') => {
  window.$sailingRaven = new SailingRaven({
    Omega: window.Omega,
    autoTrack: isPro,
  })
}

export const requestTrackStart = ({ url, params }) => {
  if (window.$sailingRaven && url) {
    try {
      // 将url中?改为. ,防止天眼删除?之后的参数
      url = url.replace('?', '.')
      return window.$sailingRaven.trackRequest.start(url, params)
    } catch (err) {
      console.log('天眼监控请求失败 start'.concat(err))
    }
  }
}

export const requestTrackEnd = ({ reqId, traceId }) => {
  if (window.$sailingRaven && reqId && traceId) {
    try {
      window.$sailingRaven.trackRequest.end(reqId, traceId)
    } catch (err) {
      console.log('天眼监控发送请求失败'.concat(err))
    }
  }
}
